import { Divider } from '@mui/material';
import { CLottie } from 'components/atoms';
import { PresetCard, ActionCard } from 'components/molecules';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type Props = { isLoading?: boolean; content: SearchResponse[] | null; closeDrawer: () => void };

export default function SearchContent({ isLoading, content, closeDrawer }: Props) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  if (isLoading) return <CLottie isFullPage />;

  if (!content || !content.length) {
    return <PresetCard type="result" />;
  }

  const doctors = content.find((item) => item.key === 'DoctorKeys')?.data;
  const departments = content.find((item) => item.key === 'DepartmentKeys')?.data;

  return (
    <div className="flex flex-col gap-10">
      {doctors && (
        <div className="flex flex-col gap-2">
          <h3 className="text-label18 text-neutral-700">{t('veterinarians')}</h3>

          <Divider className="border-neutral-200" />

          {doctors.map((doctor, idx) => (
            <ActionCard
              key={`${idx}-${doctor.value}`}
              title={`${doctor.text}`}
              imgSrc={
                doctor.subItem?.logo ?? new URL('assets/svg/user-placeholder.svg', import.meta.url).href
              }
              imgContainerClassName="aspect-square items-start w-14"
              containerClassName="!shadow-c1"
              onClick={() => {
                closeDrawer();
                navigate('doctors', { state: doctor });
                // TODO: book appointment
              }}
            />
          ))}
        </div>
      )}

      {departments && (
        <div className="flex flex-col gap-2">
          <h3 className="text-label18 text-neutral-700">{t('departments')}</h3>

          <Divider className="border-neutral-200" />

          {departments.map((department, idx) => (
            <ActionCard
              key={`${idx}-${department.value}`}
              title={`${department.text}`}
              className="min-h-[52px]"
              containerClassName="!shadow-c1"
              onClick={() => {
                closeDrawer();
                navigate('departments', { state: department });
                // TODO: book appointment
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}

